import React, { useEffect, useState } from "react";

import { RestHistoryMonitor } from "src/core/restHistoryMonitor";
import { StreamingCacheMonitor } from "src/core/streamingCacheMonitor";

type OpenMonitor = "rest" | "streaming";

export const DevMonitor = () => {
  const isDevMode = window.cnc.settings.get("dev");
  const showRestHistory = window.cnc.settings.get("restHistory");
  const [openMonitor, setOpenMonitor] = useState<OpenMonitor>();

  useEffect(() => {
    if (!isDevMode || openMonitor === undefined) {
      return undefined;
    }
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        setOpenMonitor(undefined);
        // Magnetic's Modal restores focus to the element that was focused
        // before the modal opened (i.e. the monitor trigger button) when it
        // unmounts. That restoration runs synchronously after React commits
        // the state change above, so blurring here (or inline) would fire
        // BEFORE the restoration and be immediately overwritten. Defer the
        // blur to the next task so it runs after Magnetic has re-focused
        // the trigger, leaving nothing focused.
        setTimeout(() => {
          (document.activeElement as HTMLElement)?.blur();
        }, 0);
      }
    };
    document.addEventListener("keydown", handleKeyDown, true);
    return () => {
      document.removeEventListener("keydown", handleKeyDown, true);
    };
  }, [isDevMode, openMonitor]);

  //Do not render if DevMode is disabled.
  if (!isDevMode) {
    return undefined;
  }

  return (
    <div className="cnc-monitor-buttons">
      {showRestHistory && (
        <RestHistoryMonitor
          isOpen={openMonitor === "rest"}
          onToggle={() =>
            setOpenMonitor((prev) => (prev === "rest" ? undefined : "rest"))
          }
        />
      )}
      <StreamingCacheMonitor
        isOpen={openMonitor === "streaming"}
        onToggle={() =>
          setOpenMonitor((prev) =>
            prev === "streaming" ? undefined : "streaming"
          )
        }
      />
    </div>
  );
};
